import React from 'react';

import caret from './images/caret.svg';

export const ProductDesc = ({ name, description, rating, features, shade }) => (
  <section className='column'>
    <h2>{name}</h2>
    <p>{description}</p>
    <a aria-label='View All Ratings' href='' className='mock-select' alt="View All Ratings">
      <img src={rating} alt="Product Rating" />
      <img src={caret} />
    </a>
    <section>
      <div className='row flex-space-between'>
        <div className='product__features'>
          <h4>Benefits</h4>
          <p>{features.benefits}</p>
        </div>
        <div className='product__features'>
          <h4>Finish</h4>
          <p>{features.finish}</p>
        </div>
        <div className='product__features'>
          <h4>Coverage</h4>
          <p>{features.coverage}</p>
        </div>
        <div className='product__features'>
          <h4>Key Ingredients</h4>
          <p>
            {features.keyIngredients} <a aria-label='More' href="https://www.clinique.com">More</a>
          </p>
        </div>
      </div>
    </section>
    <section className='product__shade'>
      <span>{shade.name}</span>
      <div style={{ background: shade.color }}></div>
    </section>
  </section>
);
